import React, { useCallback, useMemo } from 'react';
import { TextField, Box, Typography, Checkbox, FormControlLabel, Stack, Button } from '@mui/material';

const MainInput = ({
    titleProgram, setTitleProgram, 
    shortTitleProgram, setShortTitleProgram,
    numLessons, setNumLessons,
    trainingPeriod,setTrainingPeriod,
    linkVideo, setLinkVideo,
    linkGroup, setLinkGroup,
    isBudgetProgramm, setIsBudgetProgramm,
    commentVideo, setCommentVideo, 
    commentProgram, setCommentProgram
}) => {

    // Функция для автоматического преобразования ссылок в тексте
    const convertUrlsToLinks = (text) => {
        if (!text) return '';
        
        // Регулярное выражение для поиска URL
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        
        // Заменяем все URL на HTML ссылки
        return text.replace(urlRegex, (url) => {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #1976d2;">${url}</a>`;
        });
    };

    // Автоматически преобразованный HTML для отображения
    const processedHtml = useMemo(() => {
        return convertUrlsToLinks(commentProgram);
    }, [commentProgram]);

    const handleProgramTitleChange = useCallback((text) => {
        setTitleProgram(text.target.value);
    }, [setTitleProgram]);

    const handleProgramShortTitleChange = useCallback((text) => {
        setShortTitleProgram(text.target.value);
    }, [setShortTitleProgram]);
    
    const handleNumLessons = useCallback((text) => {
        setNumLessons(text.target.value);
    }, [setNumLessons]);

    const handleTrainingPeriod = useCallback((text) => {
        setTrainingPeriod(text.target.value);
    }, [setTrainingPeriod]);

    const handleLinkVideo = useCallback((text) => {
        setLinkVideo(text.target.value);
    }, [setLinkVideo]);

    const handleCommentVideo = useCallback((text) => {
        if(text.target.value.length < 150){
            setCommentVideo(text.target.value);
        } else {
            alert("Превышен лимит в 150 символов");
        }
    }, [setCommentVideo]);

    const handleCommentProgram = useCallback((text) => {
        if(text.target.value.length <= 300){
            setCommentProgram(text.target.value);
        } else {
            alert("Превышен лимит в 300 символов");
        }
    }, [setCommentProgram]);

    const handleLinkGroup = useCallback((text) => {
        setLinkGroup(text.target.value);
    }, [setLinkGroup]);

    const handleCheckPay = useCallback(() => {
        setIsBudgetProgramm(!isBudgetProgramm);
    }, [isBudgetProgramm, setIsBudgetProgramm]);

    return(
        <>
            <Box>
                <Typography variant="h6" gutterBottom>
                    Введите полное название образовательной программы*:
                </Typography>
                <TextField
                    id="title-program"
                    label="Введите полное название программы"
                    value={titleProgram}
                    onChange={handleProgramTitleChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                />
            </Box>
            <Box>
                <Typography variant="h6" gutterBottom>
                    Введите сокращенное название образовательной программы (можно повторить, если название вмещается в 3 слова)*:
                </Typography>
                <TextField
                    id="title-short-program"
                    label="Введите сокращенное название программы"
                    value={shortTitleProgram}
                    onChange={handleProgramShortTitleChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                />
            </Box>
            <Box>
                <Typography variant="h6" gutterBottom>
                    Введите количество занятий в неделю (например: 1 занятие, 2 занятия)*:
                </Typography>
                <TextField
                    id="num-lessons"
                    label="Введите количество занятий в неделю"
                    value={numLessons}
                    onChange={handleNumLessons}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                />
            </Box>
            <Box>
                <Typography variant="h6" gutterBottom>
                    Введите срок обучения по программе (например: 1 год, 2 года, пол года)*:
                </Typography>
                <TextField
                    id="training-period"
                    label="Введите срок обучения"
                    value={trainingPeriod}
                    onChange={handleTrainingPeriod}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                />
            </Box>
            <Box>
                <Typography variant="h6" gutterBottom>
                    Введите ссылку на видео:
                </Typography>
                <TextField
                    id="link-video"
                    label="Введите ссылку на видео"
                    value={linkVideo}
                    onChange={handleLinkVideo}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                />
            </Box>
            <Box>
                <Typography variant="h6" gutterBottom>
                    Введите комментарий к видео не более 150 символов:
                </Typography>
                <TextField
                    id="comment-video"
                    label="Введите комментарий к видео"
                    value={commentVideo}
                    onChange={handleCommentVideo}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    multiline
                    rows={2}
                />
            </Box>
            <Box>
                <Typography variant="h6" gutterBottom>
                    Введите ссылку на группу в социальных сетях:
                </Typography>
                <TextField
                    id="link-group"
                    label="Введите ссылку на соц сети"
                    value={linkGroup}
                    onChange={handleLinkGroup}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                />
            </Box>
            <Box>
                <Typography variant="h6" gutterBottom>
                    Введите примечание к образовательной программе не более 300 символов:
                </Typography>
                
                <TextField
                    label="Текст или ссылка (https:// автоматически станет ссылкой)"
                    value={commentProgram}
                    onChange={handleCommentProgram}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    multiline
                    rows={3}
                    inputProps={{ maxLength: 300 }}
                    helperText={`${commentProgram?.length || 0}/300 символов. Ссылки на https:// будут автоматически преобразованы`}
                />

                {/* Автоматический предпросмотр с преобразованными ссылками */}
                {commentProgram && (
                    <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Предпросмотр (ссылки активны):
                        </Typography>
                        <div 
                            dangerouslySetInnerHTML={{ __html: processedHtml }} 
                            style={{ wordBreak: 'break-word' }}
                        />
                    </Box>
                )}
            </Box>
            
            <FormControlLabel
                control={
                    <Checkbox 
                        checked={isBudgetProgramm} 
                        onChange={handleCheckPay} 
                    />
                }
                label={<Typography variant="h6">Бюджетная услуга*</Typography>}
            />
        </>
    )
}

export default MainInput;